import styled from 'styled-components';

const Margin = () => {
  return <Mains></Mains>;
};

const Mains = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  padding: 14vh;
`;
export default Margin;
